import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Button,
  Link,
  Grid,
  Row,
  Col,
  Panel,
  Hr,
  Margin,
  Table,
  Text,
} from 'shared/components'
import { admin } from 'routes/route.map'
import {
  MEMBER_INVOICE_TABLE,
  MEMBER_BALANCE_HISTORY_TABLE,
} from 'constants/tables'
import * as styles from './styles'

const MemberInvoicesOverviewComponent = ({
  columns,
  columnsHistory,
  columnsBankAccount,
  memberId,
  loadMemberInvoice,
  loadMemberBalance,
  loadMemberBalanceHistory,
  getBankAcountInfo,
}) => {
  const [memberBalance, setMemberBalance] = useState('')
  const [isShowBalanceHistory, setShowBalanceHistory] = useState(false)

  const getBalance = async () => {
    const balance = await loadMemberBalance(memberId)
    setMemberBalance(`${balance.fullBalance}$`)
  }

  useEffect(() => {
    getBalance()
  }, [])

  return (
    <Panel>
      <Text as="h1" size={16} bold>
        Member balance: {memberBalance}
      </Text>
      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <Margin tb={3}>
        <Row middle="xs">
          <Col xs={4} tb={1}>
            <Button
              green
              title={
                isShowBalanceHistory
                  ? 'Hide balance history'
                  : 'Show balance history'
              }
              onClick={() => {
                setShowBalanceHistory(!isShowBalanceHistory)
              }}
            ></Button>
          </Col>
        </Row>
      </Margin>
      {isShowBalanceHistory && (
        <Table
          id={MEMBER_BALANCE_HISTORY_TABLE}
          columns={columnsHistory}
          loadData={loadMemberBalanceHistory}
        />
      )}

      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <Margin tb={3}>
        <Grid>
          <Margin bottom={1} css={styles.row}>
            <Col xs={3}>
              <div css={styles.controlsWrapper}>
                <Link to={`${admin.beneficiaries.bankAccount.view(memberId)}`}>
                  <Button title="Add bank account" plain>
                    <FontAwesomeIcon size="2x" icon="plus-circle" />
                  </Button>
                </Link>
              </div>
            </Col>
          </Margin>

          <Table
            id="member-bank-account-table"
            columns={columnsBankAccount}
            loadData={getBankAcountInfo}
            showPageSizeOptions={false}
          />
        </Grid>
      </Margin>

      <Margin tb={3}>
        <Hr width="full" />
      </Margin>
      <Margin tb={3}>
        <Grid>
          <Row middle="xs">
            <Col xs={2}>
              <div css={styles.controlsWrapper}>
                <Link to={admin.beneficiaries.addInvoices.view(memberId)}>
                  <Button title="Add member invoice" plain>
                    <FontAwesomeIcon size="2x" icon="plus-circle" />
                  </Button>
                </Link>
              </div>
            </Col>
          </Row>
        </Grid>
      </Margin>
      <Table
        id={MEMBER_INVOICE_TABLE}
        columns={columns}
        loadData={(...params) => {
          getBalance()
          return loadMemberInvoice(...params)
        }}
      />
    </Panel>
  )
}

MemberInvoicesOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  columnsHistory: PropTypes.arrayOf(PropTypes.shape()),
  columnsBankAccount: PropTypes.arrayOf(PropTypes.shape()),
  loadMemberInvoice: PropTypes.func,
  loadMemberBalance: PropTypes.func,
  loadMemberBalanceHistory: PropTypes.func,
  getBankAcountInfo: PropTypes.func,
  memberId: PropTypes.number,
}

export default MemberInvoicesOverviewComponent
